<template>
  <v-card flat rounded="xl" outlined class="pa-6">
    <v-sheet class="mb-1">
      <v-row justify="center" class="text-center">
        <v-col md="2" sm="6" cols="6" order-sm="1" class="pb-3 pt-1">
          <v-btn outlined class="mr-4" color="primary" @click="setToday"
            >Hoje</v-btn
          >
        </v-col>

        <v-col
          md="8"
          sm="12"
          cols="12"
          order="first"
          order-sm="2"
          class="pb-0 pb-sm-3 pt-1">
          <v-btn fab text small color="primary" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="primary" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <span class="primary--text text-uppercase" v-if="$refs.calendar">{{
            $refs.calendar.title
          }}</span>
        </v-col>

        <v-col md="2" sm="6" cols="6" order-sm="3" class="pb-3 pt-1">
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="primary" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="changeDate('day')">
                <v-list-item-title>Dia</v-list-item-title>
              </v-list-item>
              <v-list-item @click="changeDate('week')">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="changeDate('month')">
                <v-list-item-title>Mês</v-list-item-title>
              </v-list-item>
              <v-list-item @click="changeDate('4day')">
                <v-list-item-title>4 dias</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-sheet>
    <v-sheet height="550">
      <v-calendar
        ref="calendar"
        first-interval="7"
        interval-count="16"
        v-model="focus"
        :events="events"
        @change="updateRange"
        :event-text-color="getEventTextColor"
        :type="type"
        @click:event="showEvent"
        @click:more="viewDay"
        @click:date="viewDay">
        <template v-slot:event="{ event, eventSummary }">
          <component
            class="text-center card-reserva"
            :is="{ render: eventSummary }"
            :class="{ 'not-clickable': !isSelecionavel(event.end) }">
          </component>
          <div class="text-center card-reserva">{{ event.responsavel }}</div>
        </template>
      </v-calendar>

      <slot name="legenda"></slot>
    </v-sheet>
  </v-card>
</template>

<script>
import dayjs from "dayjs"
import dataMixin from "../mixins/dataMixin"

const isSameOrBefore = require("dayjs/plugin/isSameOrBefore")
dayjs.extend(isSameOrBefore)

const RESERVA_NO_PASSADO_COR = "grey lighten-1"
const RESERVAS_PORVIR_COR = "primary"
const COR_BRANCO = "white"
const COR_CINZA = "grey-darken-2 clickable"
const DATA_HOJE = new Date()

export default {
  props: {
    ["reservas"]: {
      required: true,
    },
  },
  mixins: [dataMixin],

  data: () => ({
    dataSelecionada: new Date(),
    focus: "",
    type: "week",
    typeToLabel: {
      month: "Mês",
      week: "Semana",
      day: "Dia",
      "4day": "4 dias",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
  }),
  computed: {
    events: function () {
      let events = []
      this.reservas.forEach((reserva) => {
        const {
          titulo,
          responsavel,
          data_inicio,
          data_termino,
          horario_inicio,
          horario_termino,
          dias,
        } = reserva
        for (const dia of dias) {
          const dataInicial = dayjs(data_inicio)
          const dataFinal = dayjs(data_termino)

          const dataInicialDiaDaSemana = dataInicial.day()

          const diasDaSemana = [
            "Domingo",
            "Segunda-feira",
            "Terça-feira",
            "Quarta-feira",
            "Quinta-feira",
            "Sexta-feira",
            "Sábado",
          ]
          const indiceDiaDaSemana = diasDaSemana.findIndex((d) => d === dia.dia)
          let dataAjustada = dataInicial

          if (dataInicialDiaDaSemana !== indiceDiaDaSemana) {
            if (indiceDiaDaSemana > dataInicialDiaDaSemana) {
              dataAjustada = dataAjustada.add(
                indiceDiaDaSemana - dataInicialDiaDaSemana,
                "day"
              )
            } else {
              dataAjustada = dataAjustada.add(1, "week")
              dataAjustada = dataAjustada.subtract(
                dataInicialDiaDaSemana - indiceDiaDaSemana,
                "day"
              )
            }
          }
          while (dataAjustada.isSameOrBefore(dataFinal)) {
            const dataExata = dataAjustada.format("YYYY-MM-DD")
            const start = new Date(`${dataExata}T${horario_inicio}`)
            const end = new Date(`${dataExata}T${horario_termino}`)
            events.push({
              name: titulo,
              responsavel: responsavel.attributes.username,
              start,
              end: end,
              color:
                end > DATA_HOJE ? RESERVAS_PORVIR_COR : RESERVA_NO_PASSADO_COR,
              textColor: end > DATA_HOJE ? COR_BRANCO : COR_CINZA,
              timed: true,
            })
            dataAjustada = dataAjustada.add(1, "week")
          }
        }
      })
      return events
    },
  },

  methods: {
    changeDate(type) {
      this.type = type
      this.setToday()
    },
    viewDay({ date }) {
      this.focus = date
      this.type = "day"
    },
    setToday() {
      this.focus = ""
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    showEvent({ nativeEvent, event, day }) {
      if (this.isSelecionavel(event.end)) {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        )

        this.dataSelecionada = day.date
        this.$emit("emitData", this.dataSelecionada)
        nativeEvent.stopPropagation()
      }
    },
    updateRange({ start }) {
      this.focus = start.date
    },
    isSelecionavel(dataInicial) {
      return dataInicial > DATA_HOJE
    },
    getEventTextColor(event) {
      return event.textColor
    },
  },
}
</script>

<style scoped>
.not-clickable {
  cursor: not-allowed;
}
.card-reserva {
  white-space: break-spaces;
}
</style>

<style>
.v-calendar .v-event-timed-container {
  margin: 0;
}

.theme--light.v-calendar-events .v-event-timed {
  border: none !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media print {
  .not-clickable {
    cursor: not-allowed;
    text-align: center;
    font-size: 10px !important;
  }
  .v-event-summary {
    white-space: normal !important;
    color: rgba(0, 255, 0, 0);
  }
  .v-event-summary > strong {
    white-space: normal !important;
    color: rgba(0, 0, 0, 1);
    font-size: 10px;
  }
  .v-calendar-daily_head-weekday {
    color: black !important;
  }
  .v-calendar {
    height: auto;
    width: 100%;
    border: 1px solid gray !important;
  }

  div.v-event-timed-container div.v-event-timed.primary.white--text,
  .v-event-timed.grey.lighten-1.grey-darken-2--text.text--clickable {
    border: 1px solid gray !important;
    font-size: 10px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .v-footer,
  header.v-sheet,
  .v-calendar-daily__head .v-btn,
  .v-sheet > div:first-child .row {
    display: none;
  }

  .v-calendar-daily__day.v-future:last-child,
  .v-calendar-daily_head-day.v-future:last-child,
  .v-calendar-daily__intervals-body + div,
  .v-calendar-daily__intervals-head + div {
    display: none;
  }
}
</style>
